const context = "jupiter";
const abrev = "jupiter";

export default [

    {
        path: "/jupiter/controleaparelhosjupiter",
        name: "usuario-controle-aparelhos-jupiter",
        meta: { contexto: context, abrev: abrev },
        component: () => import("@/components/colaborador/AparelhosJupiter.vue"),
    },
];
